import { ERROR_CODES } from "@/libs/error/types";
import { UserWallet } from "@/libs/schema/api/userWallet";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import axiosWithCredentials from "../../../commons";
import { USER_WALLETS } from "../../reactQueryCacheKeys";
import { CURRENT_USER_API } from "../common";

const USER_WALLETS_API = `${CURRENT_USER_API}/wallets`;

export const makeApiUserWalletCall = async (config = {}) => {
  return await axiosWithCredentials
    .get(USER_WALLETS_API, config)
    .then(({ data }) => data);
};

export const useUserWallets = () => {
  const { isLoading, error, data } = useQuery<
    UserWallet[],
    AxiosError,
    UserWallet[]
  >([USER_WALLETS], makeApiUserWalletCall, {
    enabled: true,
    retry: false,
    useErrorBoundary: ({ response }) =>
      response !== undefined && response?.status >= ERROR_CODES.INTERNAL_ERROR,
  });
  return { isLoading, error, wallets: data };
};
